export default {
  defaultLang: "en-US",
  supportedLangs: ["en-US", "fr-CA"],
};
